import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// ISP storeroom counts. Ordering decisions are made off these numbers, so they
// are never served stale — a count submitted this morning must show up.

export function useIsps() {
  return useQuery({
    queryKey: ['ispStockCounts', 'isps'],
    queryFn: async () => (await api.get('/api/isp-stock-counts/isps')).data.isps,
    staleTime: 0,
    retry: false,
  });
}

export function useIspStockCounts(ispId) {
  return useQuery({
    queryKey: ['ispStockCounts', ispId],
    queryFn: async () => (await api.get('/api/isp-stock-counts', { params: { isp: ispId } })).data,
    enabled: Boolean(ispId),
    staleTime: 0,
    retry: false,
  });
}

// The month's install forecast per storeroom, for the manual editor.
export function useForecast(ispId, period) {
  return useQuery({
    queryKey: ['ispStockCounts', 'forecast', ispId, period],
    queryFn: async () => (await api.get('/api/isp-stock-counts/forecast',
      { params: { isp: ispId, period } })).data,
    enabled: Boolean(ispId && period),
    staleTime: 0,
    retry: false,
  });
}

export function useSaveForecast() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ isp, period, installs }) => (await api.post(
      '/api/isp-stock-counts/forecast', { isp, period, installs })).data,
    // Ordering figures are derived from the forecast, so refresh both the
    // counts and the forecast once a save lands.
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ispStockCounts'] }),
  });
}
